<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Config Variables</cs-header-title>
  <cs-header-content>
    <cs-button tertiary icon="add" (click)="addConfigAsync()">Create Config</cs-button>
  </cs-header-content>
</cs-header>

<cs-content>
  <cs-card-list>
    @for (config of configs; track config._id) {
      <cs-card>
        <cs-card-title>{{ getConfigKey(config) }}</cs-card-title>
        <cs-card-content>
          <!-- global value; a user-list key has none, being on the list IS the setting -->
          @if (!isUserListKey(config)) {
            <div class="config-section">
              @if (isJsonField(config, null, config.globalValue)) {
                <!-- a list or object: the whole value as JSON, label above a full-width box -->
                <div class="config-row config-row--stacked">
                  <span class="config-label">Global Value</span>
                  <cs-textarea class="config-json" autoadjustheight="true" [resize]="false"
                    [value]="jsonFieldText(config, null, config.globalValue)"
                    (valueChange)="onJsonInput(config, null, $event)"></cs-textarea>
                  @if (jsonFieldError(config, null); as error) {
                    <div class="config-json-error">Not valid JSON: {{ error }}</div>
                  }
                </div>
              } @else {
                <div class="config-row">
                  <span class="config-label">Global Value</span>
                  <div class="config-control">
                    @if (isBoolean(config.globalValue)) {
                      <cs-toggle [checked]="config.globalValue" (checkedChange)="toggleGlobalValue(config)"></cs-toggle>
                    } @else {
                      <cs-input type="text" [value]="formatValue(config.globalValue)" (input)="onGlobalValueInput(config, $event)"></cs-input>
                    }
                  </div>
                </div>
              }
            </div>
          }

          <!-- per-user overrides -->
          <div class="config-section">
            <div class="section-header">
              <span class="config-label">{{ isUserListKey(config) ? 'Enabled Users' : 'User Overrides' }}</span>
              <cs-button secondary small icon="add" (click)="addUserOverrideAsync(config)" [label]="'Add User' | untranslated"></cs-button>
            </div>

            @for (override of getUserOverrides(config); track override.userId) {
              @if (!isUserListKey(config) && isJsonField(config, override.userId, override.value)) {
                <!-- a list or object override: the user and remove button above, the JSON below -->
                <div class="config-row config-row--stacked user-override-row">
                  <div class="config-row">
                    <span class="user-id">{{ getUserDisplayLabel(override.userId) }}</span>
                    <cs-button secondary small icon="close" (click)="removeUserOverride(config, override.userId)"></cs-button>
                  </div>
                  <cs-textarea class="config-json" autoadjustheight="true" [resize]="false"
                    [value]="jsonFieldText(config, override.userId, override.value)"
                    (valueChange)="onJsonInput(config, override.userId, $event)"></cs-textarea>
                  @if (jsonFieldError(config, override.userId); as error) {
                    <div class="config-json-error">Not valid JSON: {{ error }}</div>
                  }
                </div>
              } @else {
                <div class="config-row user-override-row">
                  <span class="user-id">{{ getUserDisplayLabel(override.userId) }}</span>
                  <div class="config-control">
                    @if (isUserListKey(config)) {
                      <!-- nothing to set: a user on this list is on -->
                    } @else if (isBoolean(override.value)) {
                      <!-- [ariaLabel] names the switch: the remove button shares this row, so
                           there is no row text the toggle can take its name from -->
                      <cs-toggle [ariaLabel]="getUserDisplayLabel(override.userId) | untranslated"
                        [checked]="override.value" (checkedChange)="toggleUserValue(config, override.userId)"></cs-toggle>
                    } @else {
                      <cs-input type="text" [value]="formatValue(override.value)" (input)="onUserValueInput(config, override.userId, $event)"></cs-input>
                    }
                  </div>
                  <cs-button secondary small icon="close" (click)="removeUserOverride(config, override.userId)"></cs-button>
                </div>
              }
            } @empty {
              <div class="empty-overrides">{{ isUserListKey(config) ? 'No users enabled' : 'No user overrides' }}</div>
            }
          </div>

          <div class="config-actions">
            <cs-button secondary small icon="trash" (click)="handleDelete($event, config)" [label]="'Delete' | untranslated"></cs-button>
            <cs-button primary small (click)="handleSave($event, config)" [label]="'Save' | untranslated"></cs-button>
          </div>
        </cs-card-content>
      </cs-card>
    }
  </cs-card-list>
</cs-content>
